export default __webpack_public_path__ + "static/media/golbet24_receipt.4ba08011.jpg";